/* Etiquette — PDP color swatches: map color name -> hex dot */
(function () {
  var COLOR_MAP = {
    "aqua": "#5FBFBF", "beige": "#E8DCC4", "black": "#1A1A1A", "blue": "#2B5DAF",
    "brown": "#6B4423", "dark blue": "#1B2A4A", "dark green": "#1F3D2B", "dark grey": "#4A4A4A",
    "fawn": "#C9A66B", "green": "#3C8C40", "grey": "#9E9E9E", "khakhi": "#8F8050",
    "l blue": "#A9C7E8", "lavender": "#9086A6", "light blue": "#A9C7E8", "light grey": "#CFCFCF",
    "maroon": "#6E1423", "mehandi green": "#7A7D2E", "mehndi green": "#7A7D2E",
    "multi": "linear-gradient(135deg,#e74c3c,#f1c40f,#2ecc71,#3498db,#9b59b6)",
    "multicolor": "linear-gradient(135deg,#e74c3c,#f1c40f,#2ecc71,#3498db,#9b59b6)",
    "mustard": "#D4A017", "musturd": "#D4A017", "navy blue": "#16243E",
    "off white": "#F3EFE7", "olive green": "#6B7A3C", "orange": "#E8731C",
    "peach": "#F2B8A2", "pink": "#E8A0BF", "purple": "#493657", "rama green": "#2E8B7A",
    "rani": "#D6296B", "red": "#C8102E", "rust": "#A8492B", "sea green": "#2E8B7A",
    "teal": "#198080", "white": "#FFFFFF", "wine": "#5C1A2B", "yellow": "#F2C500"
  };

  function colorFor(name) {
    if (!name) return null;
    return COLOR_MAP[name.trim().toLowerCase()] || null;
  }

  function paintSwatches(root) {
    root = root || document;
    var fieldsets = root.querySelectorAll('fieldset.product-form__input');
    fieldsets.forEach(function (fs) {
      var legend = fs.querySelector('legend, .form__label');
      if (!legend || !/colou?r/i.test(legend.textContent)) return;

      fs.classList.add('etq-color-fieldset');

      fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var label = fs.querySelector('label[for="' + input.id + '"]');
        if (!label || label.dataset.etqSwatched === '1') return;

        var name = (input.value || '').trim();
        var hex = colorFor(name);
        label.dataset.etqSwatched = '1';
        label.classList.add('etq-swatch');
        label.setAttribute('title', name);

        var dot = document.createElement('span');
        dot.className = 'etq-swatch__dot';
        if (hex) {
          dot.style.background = hex;
        } else {
          dot.classList.add('etq-swatch__dot--unknown');
        }
        var lower = name.toLowerCase();
        if (lower === 'white' || lower === 'off white') {
          dot.classList.add('etq-swatch__dot--light');
        }
        label.insertBefore(dot, label.firstChild);
      });
    });
  }

  function init() { paintSwatches(document); }

  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }

  document.addEventListener('shopify:section:load', function () { paintSwatches(document); });
  var mo = new MutationObserver(function () { paintSwatches(document); });
  mo.observe(document.body, { childList: true, subtree: true });

  // Bridge: clicked color name -> gallery media (durable, no variant-id/timing dependency)
  (function bridgeGallery() {
    function getColorMap() {
      var el = document.querySelector('[id^="EtqColorMedia-"]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    function switchGalleryForMedia(mediaId) {
      var galleryRoot = document.querySelector('[id^="EtqGallery-"]');
      if (!galleryRoot || !mediaId) return;
      var main = galleryRoot.querySelector('.etq-gallery__main');
      var isMobile = window.matchMedia('(max-width: 989px)').matches;
      galleryRoot.querySelectorAll('.etq-gallery__slide').forEach(function (s) {
        var on = s.dataset.mediaId === String(mediaId);
        s.classList.toggle('is-active', on);
        if (on && isMobile && main) {
          main.scrollTo({ left: s.offsetLeft - main.offsetLeft, behavior: 'smooth' });
        }
      });
      galleryRoot.querySelectorAll('.etq-gallery__thumb').forEach(function (t) {
        t.classList.toggle('is-active', t.dataset.mediaId === String(mediaId));
      });
    }

    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      if (!/^(Color|option)/i.test(input.name || '')) return;
      var map = getColorMap();
      if (!map) return;
      var key = (input.value || '').trim().toLowerCase();
      if (map[key]) {
        switchGalleryForMedia(map[key]);
      } else {
        var galleryRoot = document.querySelector('[id^="EtqGallery-"]');
        var firstSlide = galleryRoot && galleryRoot.querySelector('.etq-gallery__slide');
        if (firstSlide) switchGalleryForMedia(firstSlide.dataset.mediaId);
      }
    }, true);
  })();
})();